export default __webpack_public_path__ + "static/media/daima7.ed326eff.jpg";